import { render } from "./pros-cons-pitch.vue?vue&type=template&id=7ad59183&scoped=true&ts=true"
import script from "./pros-cons-pitch.vue?vue&type=script&lang=ts"
export * from "./pros-cons-pitch.vue?vue&type=script&lang=ts"

import "./pros-cons-pitch.vue?vue&type=style&index=0&id=7ad59183&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad59183"]])

export default __exports__